import React, {
  useEffect,
} from "react";
import { useService } from "@xstate/react/fsm";

import {
  CONSTRAIN_ON_X_AXIS,
  X_ANGLE_DISTANCE_VARIANCE,
  Y_ANGLE_DISTANCE_VARIANCE,
  BLUR_DETECTION_ENABLED
} from "./MugShotConfig"

import "./FaceScanner.css";

const PositionChecker =
    ({ send, targetYAngles, targetXAngle, currentImage, machineContext}) => {

  const image = currentImage;

  // How much can the Y angle vary from our target angle.
  const angleYDistanceVariance = Y_ANGLE_DISTANCE_VARIANCE;

  // How much can the X angle vary from our target angle if constrain on X axis is enabled.
  const angleXDistanceVariance = X_ANGLE_DISTANCE_VARIANCE;

  useEffect(() => {
    // This indicates that we haven't set the angles yet.
    if(image === undefined || image.yAngle === -1 || image.xAngle === -1) {
      return;
    }

    for (const imageName in targetYAngles) {
      let targetYAngle = targetYAngles[imageName];
      
      let angleYOK = Math.abs(targetYAngle - image.yAngle) < angleYDistanceVariance;
      
      let angleXOK = CONSTRAIN_ON_X_AXIS ?
      Math.abs(targetXAngle - image.xAngle) < angleXDistanceVariance : true;

      if ( angleYOK && angleXOK ) {

        if (BLUR_DETECTION_ENABLED ) {

          let lastBlurValue = machineContext.last_blur_measure[imageName];

          // The image is less blurry than the previously cached version so keep it.
          if (currentImage.blur_edge_ratio > lastBlurValue) {
            //console.log(`Using image, as it is sharper than the last. ${currentImage.blur_edge_ratio} > ${lastBlurValue}` );
            machineContext.last_blur_measure[imageName] = currentImage.blur_edge_ratio;
            send("POSITIONED", {currentImageName: imageName, currentImage: image.image, currentImageData: image.imageData});
          }
        } else {
          send("POSITIONED", {currentImageName: imageName, currentImage: image.image, currentImageData: image.imageData });
        }
      }

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [send, image, targetYAngles, targetXAngle, angleXDistanceVariance, angleYDistanceVariance]);

  return null;
};


const ImageGrabber = ({
  machineName,
  machine,
  coords,
  currentCapturedImage,
}) => {

  const [state, send] = useService(machine);
  const { angleX, yAngles } = state.context;

  return (
    <>
      {coords && (
        <PositionChecker
                     send={send}
                     targetYAngles={yAngles}
                     targetXAngle={angleX}
                     currentImage={currentCapturedImage}
                     machineContext={state.context}
        />
      )}
    </>
  );
};

export default ImageGrabber;
